import {Container} from '../../components/Container';
import React, {memo} from 'react';
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {MediaRenderer} from '../../components/MediaRenderer';
import {ControlRenderer} from '../../components/ControlRenderer';
import {Row} from '../../components/Row';
import {backButtonToggle, groupSettingAction, scenarioSettingAction} from "../../store/ui/actions";
import {CONTROL_TYPE_ID_CURTAIN, CONTROL_TYPE_ID_DIMMER, CONTROL_TYPE_ID_LIGHT} from "../../types/control";

export const PageScreen = memo(function PageScreen() {
    const params = useParams<{ id: string }>();
    const menuEntity = useSelector(state => state.control.menuList.find(i => i.id === params.id));
    const dispatch = useDispatch();
    dispatch(backButtonToggle({is_open: true, to: '/'}));
    dispatch(groupSettingAction({visible: false}));
    dispatch(scenarioSettingAction({visible: false}));

    const groupControls = menuEntity.content_list?.find((item) => {
        return [CONTROL_TYPE_ID_LIGHT, CONTROL_TYPE_ID_DIMMER, CONTROL_TYPE_ID_CURTAIN].indexOf(item.relational_id) > -1
    });

    if (groupControls) {
        dispatch(groupSettingAction({visible: false}));
        dispatch(scenarioSettingAction({visible: false}));
    } else {
        dispatch(groupSettingAction({visible: false}));
        dispatch(scenarioSettingAction({visible: true}));
    }

    return (
        <Container>
            <div className="page-wrapper">
                <Row>
                    {
                        menuEntity?.content_list?.map((content, i) => {
                            if (content.type === 'control') {
                                return (
                                    <ControlRenderer
                                        key={`control_${menuEntity.id}_${i}`}
                                        controlTypeId={content.relational_id}/>
                                );
                            } else if (content.type === 'media') {
                                return (
                                    <MediaRenderer
                                        key={`media_${menuEntity.id}_${i}`}
                                        type={content.relational_id}/>
                                );
                            }
                            return null;
                        })
                    }
                </Row>
            </div>
        </Container>
    );
});
